import { isDate as isDateJs } from "date-fns";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isDate = (input: any): input is Date => isDateJs(input);

export { isDate };
